import { GameApplicationType } from '../../core/enums';
import { BaseElementDrawer } from '../../core/base/BaseElementDrawer';
import { GamePadMobileDrawer } from './drawers/GamePadMobileDrawer';
import { GamePadWebDrawer } from './drawers/GamePadWebDrawer';
import { GamePadLandscapeDrawer } from './drawers/GamePapLandscapeDrawer';

export class GamePadDrawer extends BaseElementDrawer {
}

export const gamePad = new GamePadDrawer({
  [GameApplicationType.mobile]: new GamePadMobileDrawer(),
  [GameApplicationType.web]: new GamePadWebDrawer(),
  [GameApplicationType.landscape]: new GamePadLandscapeDrawer(),
});